module.exports = __webpack_public_path__ + "img/1.ca970b24.png";